import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from 'lucide-react';
import { CERTIFICATION, CONTACT_EMAIL, CONTACT_PHONES, OFFICES, PRODUCTS } from '../data/site';
export function SiteFooter() {
  return <footer className="bg-ink-950 text-ink-300" data-id="element-139" data-mp="3mfyf0a3wvfpz">
      <div className="mx-auto max-w-container px-6 py-16 lg:px-10 lg:py-20" data-id="element-140" data-mp="3hiprdtzzujhc">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-141" data-mp="3hglq7jthbykr">
          <div data-id="element-142" data-mp="3diflsig45v30">
            <div className="flex items-center gap-3" data-id="element-143" data-mp="3derulpy55krg">
              <span className="block h-9 w-6 bg-bronze-500" style={{
              clipPath: 'polygon(14% 0, 86% 0, 100% 100%, 0 100%)'
            }} aria-hidden="true" data-id="element-144" data-mp="38gqbj50ptlfz" />
              <span className="text-lg font-semibold tracking-tight text-white" data-id="element-145" data-mp="2ykvo7wljr26v">
                KEYSTONE
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-ink-400" data-id="element-146" data-mp="11oxwrydoco6p">
              We build the systems African businesses and institutions run on —
              property, land, and community finance, in one platform each.
            </p>
            <p className="mt-6 text-sm italic text-bronze-300" data-id="element-147" data-mp="1aqzu55h086ct">
              Ideas that change the world
            </p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="mt-6 block text-sm font-medium text-white underline decoration-bronze-500 underline-offset-4 transition-colors duration-150 ease-out hover:text-bronze-300" data-id="element-148" data-mp="vuig26hfkdmk">
              {CONTACT_EMAIL}
            </a>
            <ul className="mt-3 space-y-1" data-id="element-149" data-mp="1tfo79598x7e1">
              {CONTACT_PHONES.map(phone => <li key={phone.tel} data-id="element-150" data-mp="1er9vu5xrkalv">
                  <a href={`tel:${phone.tel}`} className="whitespace-nowrap text-sm text-ink-300 transition-colors duration-150 ease-out hover:text-bronze-300" data-id="element-151" data-mp="1jqmqhcuvmlz0">
                    {phone.display}
                  </a>
                </li>)}
            </ul>
            <p className="mt-3 flex items-center gap-2 text-xs text-ink-400" data-id="element-152" data-mp="2m1uztynttjzl">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-bronze-400" aria-hidden="true" data-id="element-153" data-mp="2h3bcbttl4054" />
              {CERTIFICATION.label}
            </p>
          </div>

          <nav aria-label="Products" data-id="element-154" data-mp="2d4cawj72alif">
            <h2 className="text-xs font-medium uppercase tracking-[0.18em] text-ink-500" data-id="element-155" data-mp="283o9d3l7im9y">
              Products
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-156" data-mp="234tta9emjbtj">
              {PRODUCTS.map(product => <li key={product.slug} data-id="element-157" data-mp="1ycaexa844cno">
                  <Link to={product.to ?? `/products#${product.slug}`} className="text-sm text-ink-300 transition-colors duration-150 ease-out hover:text-bronze-300" data-id="element-158" data-mp="1yb8syapk65r6">
                    {product.name}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Company" data-id="element-159" data-mp="1fe7n6no6k1m6">
            <h2 className="text-xs font-medium uppercase tracking-[0.18em] text-ink-500" data-id="element-160" data-mp="1ff95nd7izqdx">
              Company
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-161" data-mp="3w0xjga0duenb">
              {[{
              label: 'About',
              to: '/about'
            }, {
              label: 'Contact',
              to: '/contact'
            }, {
              label: 'Book a demo',
              to: '/contact'
            }].map(link => <li key={link.label} data-id="element-162" data-mp="8vocyhech1rm">
                  <Link to={link.to} className="text-sm text-ink-300 transition-colors duration-150 ease-out hover:text-bronze-300" data-id="element-163" data-mp="38bbl1oru43gd">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-164" data-mp="3m39n5fn4oz31">
            <h2 className="text-xs font-medium uppercase tracking-[0.18em] text-ink-500" data-id="element-165" data-mp="3m3rogqone3ht">
              Where we are
            </h2>
            <ul className="mt-5 space-y-4" data-id="element-166" data-mp="2pklhdxufwcmg">
              {OFFICES.map(office => <li key={office.city} className="text-sm leading-relaxed" data-id="element-167" data-mp="2tkvstq103v8p">
                  <span className="block font-medium text-white" data-id="element-168" data-mp="2aivchpxhglvc">{office.city}</span>
                  <span className="block text-ink-400" data-id="element-169" data-mp="25jifwdgt80fk">{office.line1}</span>
                  <span className="block text-ink-400" data-id="element-170" data-mp="2k7n4fy2jn669">{office.line2}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-ink-800 pt-6 text-xs text-ink-500 sm:flex-row sm:items-center sm:justify-between" data-id="element-171" data-mp="2ffc44u3w5id6">
          <p data-id="element-172" data-mp="2o9gwxj2l53vc">© {new Date().getFullYear()} Keystone Technologies. All rights reserved.</p>
          <p data-id="element-173" data-mp="336he4sn5hgfk">Privacy · Security · Responsible disclosure</p>
        </div>
      </div>
    </footer>;
}